






































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import I18n from '../I18n';
import { Org } from '../types';
import { SelectionFieldRow } from '../components';
import SingleOrgSelection from './SingleOrgSelection.vue';
import * as common from "@/modules/budget/staffing-table/common";
import { isEqualsToOrg } from "@/modules/budget/staffing-table/common";


const decorationVariants = {
    fieldRow: null,
    input: 'input',
};
const modelChangeEvent = 'change';
const i18n = new I18n('modules.budget.staffing_table.components.SingleOrgField');


@Component({
    name: 'SingleOrgField',
    components: {
        'field-row': SelectionFieldRow,
        'org-selection': SingleOrgSelection,
    },
})
export default class SingleOrgField extends Vue {
    // region Model, properties
    @Model(
        modelChangeEvent,
        {
            type: Object,
            required: false,
            default: null,
        },
    )
    public value!: Org | null;

    @Prop({
        type: String,
        required: false,
        default: () => null,
    })
    public decorationVariant!: string | null;
    // endregion

    private resetBudgetVariant() {
        common.store.budgetVariant = null
    }

    // region Lifecycle
    // noinspection JSUnusedLocalSymbols
    protected created() {
        // region Model, properties
        this.$watch('value', (value: Org | null) => {
            if (!isEqualsToOrg(this.localValue, value)) {
                this.localValue = value;
            }
        });
        // endregion


        // region Org
        this.$watch('localValue', (localValue: Org | null) => {
            if (!isEqualsToOrg(this.value, localValue)) {
                this.resetBudgetVariant()
                this.$emit(modelChangeEvent, localValue);
            }
        });
        // endregion
    }

    // noinspection JSUnusedLocalSymbols
    protected mounted() {
        if (!isEqualsToOrg(this.value, this.localValue)) {
            this.localValue = this.value;
        }
    }
    // endregion


    // region Util
    public i18n = i18n;
    public decorationVariants = decorationVariants;
    // endregion


    // region Org
    public localValue: Org | null = null;

    public get orgText(): string | null {
        const org = this.localValue;
        if (org === null) return null;

        const type = org.type;
        let result = '';
        if (org.type === 'GU') {
            const gu = org.gu;
            result = gu.code;
            if (this.i18n.isKazakh) {
                result += ' - ' + gu.nameKk || '';
            } else {
                result += ' - ' + gu.nameRu;
            }
        } else if (org.type === 'KGKP') {
            const kgkp = org.kgkp;
            result = kgkp.bin;
            if (this.i18n.isKazakh) {
                result += ' - ' + kgkp.nameKk;
            } else {
                result += ' - ' + kgkp.nameRu;
            }
        } else {
            throw new Error(`Cannot process organization with unknown type \"${type}\"`);
        }

        return result;
    }
    // endregion


    // region Modal
    public modalOrg: Org | null = null;

    public modalVisible = false;

    public get modalOkDisabled(): boolean { return this.modalOrg === null; }

    public onModalOk() { this.localValue = this.modalOrg; }
    // endregion


    // region Field
    public onFieldClick() {
        this.modalOrg = this.localValue;
        this.modalVisible = true;
    }
    // endregion
}
